import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CardValidationDetails, CardValidationService } from './../../services/card-validation.service';

const defaultShopButtonUrl = 'https://www.trivita';

@Component({
  selector: 'gca-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss']
})
export class ThanksComponent implements OnInit, OnDestroy {
  cardValidationDetails: CardValidationDetails;
  shopButtonUrl: string;

  constructor(private cardValidationService: CardValidationService, private router: Router) {}

  ngOnInit() {
    const shopButtonUrlPart = localStorage.getItem('countryId') === '2' ? '.ca' : '.com';
    this.shopButtonUrl = defaultShopButtonUrl + shopButtonUrlPart;

    if (localStorage.getItem('shopButtonUrl')) {
      this.shopButtonUrl += localStorage.getItem('shopButtonUrl');
    }

    if (localStorage.getItem('sourceId')) {
      this.shopButtonUrl += `&sourceId=${(localStorage.getItem('sourceId'))}`;
    }

    this.cardValidationDetails = this.cardValidationService.cardValidationDetails;

    if (!this.cardValidationDetails) {
      this.router.navigate(['/card-activation']);
    }
  }

  ngOnDestroy() {
    this.cardValidationService.removeCardValidationDetails();
  }

}
